const { get, post, postWithQuery } = require('services/api');
import { actions as formActions } from 'react-redux-form';
import raHireManagementPlanActions from 'actions/RAHireManagementPlan';
import raPortfolioDistributionActions from 'actions/RAPortfolioDistribution';
import apiURLBuilder from 'core/apiURLBuilder';
import Api from '../services/api';
import { getReferenceCodeByCountry } from 'utilities/multiLanguageHelper';
import { mapDataToAnswers, wizzardStatus, getCurrentStep } from 'utilities/RASuitabilityTestHelper';
import {
    horizonSliderValueToAnswer,
    incomeValueToAnswer,
    mapInvestmentRowAnswerToValue,
    mapInvestmentRowValueToAnswer,
    networthSliderValueToAnswer,
    outcomeValueToAnswer,
    riskSliderValueToAnswer,
} from 'utilities/RASuitabilityTestHelper';
import Storage from 'utilities/storage';
import actionTypes from 'constants/RAConstants/actionTypes';
import {
    SUITABILITY_TEST_STEP_TO_ANSWERS,
    SUITABILITY_TEST_UNSIGNED,
    SUITABILITY_TEST_VALID,
    SUITABILITY_TEST_REDO,
    SUITABILITY_TEST_PROFILE_MODEL_ANSWERS,
} from 'constants/RAConstants/index';
import checkStatusActions from './RACheckStatus';
import preLoaderActions from './preLoaderActions';
import { generateRoboLanguageParameter } from 'utilities/generateRoboLanguageParameter';
import { goToErrorsView } from './errorViewNavigation';

const expandAccordionRow = expandedRowId => ({
    type: actionTypes.RA_SUITABILITY_TEST_EXPAND_ACCORDION_ROW,
    payload: {
        expandedRowId,
    },
});

const getTestResultInProgress = () => ({
    type: actionTypes.RA_SUITABILITY_GET_TEST_RESULT_REQUEST,
});

const getTestResultSuccess = response => ({
    type: actionTypes.RA_SUITABILITY_GET_TEST_RESULT_SUCCESS,
    payload: response,
});

const getTestResultFailure = error => ({
    type: actionTypes.RA_SUITABILITY_GET_TEST_RESULT_FAILURE,
    payload: { error },
});

const getTestResult =
    (accessToken, category = 2) =>
    dispatch => {
        dispatch(getTestResultInProgress());

        const requestData = {
            header: {
                Authorization: `Bearer ${accessToken}`,
                language: generateRoboLanguageParameter(),
            },
        };

        return get(apiURLBuilder.getURL('raGetRiskCategory', { category }), requestData)
            .then(response => dispatch(getTestResultSuccess(response.body)))
            .catch(error => {
                if (error.error) {
                    return dispatch(getTestResultFailure(error.error.description));
                }
                throw error;
            });
    };

const getTestQuestionsRequest = () => ({
    type: actionTypes.RA_SUITABILITY_GET_TEST_QUESTIONS_REQUEST,
});

const getTestQuestionsSuccess = (data, readOnly) => ({
    type: actionTypes.RA_SUITABILITY_GET_TEST_QUESTIONS_SUCCESS,
    payload: { data, readOnly },
});

const getTestQuestionsFailure = error => ({
    type: actionTypes.RA_SUITABILITY_GET_TEST_QUESTIONS_FAILURE,
    payload: { error },
});

const getTestQuestions =
    (accessToken, readOnly = false) =>
    (dispatch, getState) => {
        const checkStatus = getState().raCheckStatus.get('checkStatus');
        const retrieveTestQuestions = () => {
            dispatch(getTestResult(accessToken, 0));
            Storage.cookies.remove('RASuitabilityStarted');
            dispatch(preLoaderActions.hidePreLoader());
        };

        switch (checkStatus) {
            case SUITABILITY_TEST_UNSIGNED:
            case SUITABILITY_TEST_REDO:
                retrieveTestQuestions();
                break;
            case SUITABILITY_TEST_VALID:
                retrieveTestQuestions();
                dispatch(raPortfolioDistributionActions.requestPortfolioDistribution(accessToken));
                dispatch(raHireManagementPlanActions.getPDFContract(accessToken));
                break;
            default: {
                dispatch(preLoaderActions.showPreLoader());
                dispatch(getTestQuestionsRequest());
                const requestData = {
                    header: {
                        Authorization: `Bearer ${accessToken}`,
                        language: generateRoboLanguageParameter(),
                    },
                };

                return Api.get(
                    apiURLBuilder.getURL('raRetrieveTestQuestions', {
                        status: checkStatus,
                    }),
                    requestData
                )
                    .then(response => {
                        const answeredQuestions = response.body.answered;
                        if (answeredQuestions) {
                            const answers = answeredQuestions.nextAnswer;
                            const mappedAnswers = mapDataToAnswers(answers);

                            Object.entries(mappedAnswers).forEach(([idQuestion, answer]) => {
                                dispatch(
                                    formActions.change(
                                        `${SUITABILITY_TEST_PROFILE_MODEL_ANSWERS}.${idQuestion}`,
                                        answer
                                    )
                                );
                            });
                        }
                        dispatch(getTestQuestionsSuccess(response.body, readOnly)).then(
                            dispatch(preLoaderActions.hidePreLoader())
                        );
                    })
                    .catch(error => {
                        if (error.error) {
                            dispatch(getTestQuestionsFailure(error.error.description)).then(
                                dispatch(preLoaderActions.hidePreLoader())
                            );
                        } else {
                            throw error;
                        }
                    });
            }
        }
    };

const sendTestInProgress = () => ({
    type: actionTypes.RA_SUITABILITY_TEST_SEND_TEST_IN_PROGRESS,
});

const sendTestSuccess = response => ({
    type: actionTypes.RA_SUITABILITY_TEST_SEND_TEST_SUCCESS,
    payload: {
        response,
    },
});

const sendTestFailure = error => ({
    type: actionTypes.RA_SUITABILITY_TEST_SEND_TEST_FAILURE,
    payload: {
        error,
    },
});

const mapAnswers = (userProfile, immRASuitabilityTest, currentStep, mappedAnswers) => {
    return immRASuitabilityTest.get('answers').reduce((acc, answer, idQuestion) => {
        const mappedAnswer = mappedAnswers[idQuestion] || answer;

        if (!mappedAnswer) {
            return acc;
        }

        const idAnswerByIdQuestion = {
            218: horizonSliderValueToAnswer(mappedAnswer),
            219: riskSliderValueToAnswer(mappedAnswer),
            320: incomeValueToAnswer(mappedAnswer),
            321: outcomeValueToAnswer(mappedAnswer),
            322: networthSliderValueToAnswer(mappedAnswer),
        };

        const idAnswer = [idAnswerByIdQuestion[idQuestion] || mappedAnswer.toString()];

        return [...acc, { idAnswer, idQuestion }];
    }, []);
};

const modifyAnswers404And405IfAreWrong = questions => {
    const answerQuestion404 = questions[404];
    const answerQuestion405 = questions[405];
    if (
        answerQuestion404 === 'answer2' ||
        answerQuestion404 === 'answer3' ||
        answerQuestion405 === 'answer2' ||
        answerQuestion405 === 'answer3'
    ) {
        return { ...questions, 404: 'answer1', 405: 'answer1' };
    }

    return questions;
};

const sendLogs = () => (_, getState) => {
    const immSuitabilityTest = getState().raSuitabilityTest;
    const userProfile = getState().userProfile;
    const { questions, answers } = immSuitabilityTest.toJS();
    const userProfileAnswers = userProfile?.RASuitabilityTest?.answers;
    const questionsToLog = ['401', '402', '403', '404', '405', '500'];
    const ONBOARDING_CHANNEL = 'ONB';

    const mappedQuestions = questionsToLog.map(questionID => {
        if (!userProfileAnswers[questionID] && !answers[questionID]) {
            return null;
        }
        const question = questions[questionID];
        const answerId = userProfileAnswers[questionID] ?? answers[questionID];
        const dataAnswer = question.answers.find(answer => answer.id === answerId);

        return {
            answerId: dataAnswer?.id,
            answerText: dataAnswer?.label?.title ?? dataAnswer?.text,
            questionId: questionID,
            questionText: question?.title,
        };
    });

    const questionWithAnswer = mappedQuestions.filter(question => question);
    const customerType = Array.from(userProfile.userId)[0];
    const customerCode = userProfile.userId.substring(1);

    const params = {
        query: {
            customerType,
            customerCode,
        },
        body: {
            channel: ONBOARDING_CHANNEL,
            originCountry: getReferenceCodeByCountry().toUpperCase(),
            questionList: questionWithAnswer,
        },
        header: {},
    };

    return postWithQuery(apiURLBuilder.getURL('raSendLogsForNewTestQuestions'), params);
};

const sendTest = accessToken => (dispatch, getState) => {
    const userProfile = getState().userProfile;
    const mappedAnswers = userProfile?.RASuitabilityTest?.answers;
    const modifiedAnswers = modifyAnswers404And405IfAreWrong(mappedAnswers);

    if (modifiedAnswers) {
        const immCheckStatus = getState().raCheckStatus;
        const RATestWizard = getState().raSuitabilityTestWizard;
        const immRASuitabilityTest = getState().raSuitabilityTest;
        const key = immRASuitabilityTest.getIn(['lastAnswer', 'step', 'category']);
        const isExitTest = !immRASuitabilityTest.get('lastAnswer');
        const index = immRASuitabilityTest.getIn(['lastAnswer', 'step', 'step']);
        const { retakeToStep, retakeToSubStep } = wizzardStatus({ key, index, isExitTest });
        const savedStepIndex = getCurrentStep(retakeToStep, retakeToSubStep);
        let currentStepIndex = savedStepIndex;
        const wizardStep = RATestWizard.currentStep;
        const wizardSubStep = RATestWizard.currentSubStep;
        const wizardStepIndex = getCurrentStep(wizardStep, wizardSubStep);
        if (savedStepIndex < wizardStepIndex) {
            currentStepIndex = wizardStepIndex;
        }

        const status = immCheckStatus.get('checkStatus');
        const questions = mapAnswers(userProfile, immRASuitabilityTest, currentStepIndex, modifiedAnswers);
        const request = {
            header: {
                Authorization: `Bearer ${accessToken}`,
            },
            query: {
                allQuestions: true,
                status,
                questions,
            },
        };

        dispatch(sendTestInProgress());
        dispatch(preLoaderActions.showPreLoader());

        return post(apiURLBuilder.getURL('raSendTestQuestions'), request)
            .then(response => {
                dispatch(getTestResult(accessToken, 0));
                dispatch(formActions.change('userProfile.testStarted', false));
                Storage.cookies.remove('RASuitabilityStarted');
                dispatch(sendTestSuccess(response));
                dispatch(checkStatusActions.checkStatus(accessToken)).then(() =>
                    dispatch(getTestQuestions(accessToken))
                );
            })
            .catch(error => {
                if (error.error) {
                    dispatch(sendTestFailure(error.error.description)).then(dispatch(preLoaderActions.hidePreLoader()));
                } else {
                    throw error;
                }
            });
    }
};

const reset = () => ({
    type: actionTypes.RA_SUITABILITY_TEST_RESET,
});

const selectAccordionButton = (rowId, buttonId) => dispatch => {
    dispatch({
        type: actionTypes.RA_SUITABILITY_TEST_SELECT_ACCORDION_BUTTON,
        payload: {
            rowId,
            buttonId,
        },
    });
};

const updateAnswerByQuestionId = (questionId, value) => dispatch => {
    dispatch({
        type: actionTypes.RA_SUITABILITY_TEST_UPDATE_ANSWER_BY_QUESTION_ID,
        payload: {
            questionId,
            value,
        },
    });
};

const checkCoherenceValidations = (currentQuestion, currentAnswer, immSuitabilityTest, userProfile) => {
    const questionsToCheck = immSuitabilityTest.getIn(['validations', currentQuestion, currentAnswer], []);
    let error;

    questionsToCheck.some((question, questionId) => {
        const questionAnswer = userProfile.RASuitabilityTest.answers[questionId];
        const message = immSuitabilityTest.getIn([
            'validations',
            currentQuestion,
            currentAnswer,
            questionId,
            questionAnswer,
        ]);
        error = message;

        return error;
    });

    return error;
};

const checkAccordionCoherence = (currentQuestion, immSuitabilityTest, userProfile) => {
    // Questions (F, G, H, I, J, K, L) respectively from step 4 to sum when answer selected is not coherent
    const step4Questions = ['110', '111', '112', '113', '114', '115', '116'];
    let errorMessage;
    let error;

    const count = step4Questions.reduce((prev, questionId) => {
        const answer = userProfile?.RASuitabilityTest?.answers?.[questionId];

        errorMessage = checkCoherenceValidations(
            currentQuestion,
            mapInvestmentRowValueToAnswer(questionId),
            immSuitabilityTest,
            userProfile
        );

        return errorMessage ? prev + mapInvestmentRowAnswerToValue(answer) : prev;
    }, 0);

    if (count > 1) {
        error = errorMessage;
    }

    return error;
};

const resetCoherenceError = () => ({
    type: actionTypes.RA_SUITABILITY_TEST_RESET_COHERENCE_ERROR,
});

const setCoherenceError = (message, allowToPass = false) => ({
    type: actionTypes.RA_SET_ERROR_COHERENCE_VALIDATION,
    payload: {
        message,
        allowToPass,
    },
});

const validateStep = currentStep => (dispatch, getState) => {
    const immSuitabilityTest = getState().raSuitabilityTest;
    const userProfile = getState().userProfile;
    const currentQuestion = SUITABILITY_TEST_STEP_TO_ANSWERS[currentStep];
    const currentAnswer = userProfile?.RASuitabilityTest?.answers?.[currentQuestion];

    let errorMessage = '';
    let warningMessage = '';
    let mappedAnswer = '';
    let valid = true;

    switch (currentQuestion) {
        case '103':
            errorMessage = checkCoherenceValidations(currentQuestion, currentAnswer, immSuitabilityTest, userProfile);
            valid = !errorMessage;
            break;
        case '104':
            warningMessage = checkAccordionCoherence(currentQuestion, immSuitabilityTest, userProfile);
            break;
        case '218':
            mappedAnswer = horizonSliderValueToAnswer(currentAnswer);
            errorMessage = checkCoherenceValidations(currentQuestion, mappedAnswer, immSuitabilityTest, userProfile);
            valid = !errorMessage;
            break;
        case '219':
            mappedAnswer = riskSliderValueToAnswer(currentAnswer);
            errorMessage = checkCoherenceValidations(currentQuestion, mappedAnswer, immSuitabilityTest, userProfile);
            valid = !errorMessage;
            break;
        default:
            break;
    }

    if (valid) {
        if (warningMessage) {
            dispatch(setCoherenceError(warningMessage));
        } else {
            dispatch(setCoherenceError('', true));
        }
    } else {
        dispatch(setCoherenceError(errorMessage));
    }
};

const clearCoherenceError = () => dispatch => {
    dispatch(setCoherenceError('', true));
};

const signTestRequest = () => ({
    type: actionTypes.RA_SUITABILITY_TEST_SIGN_TEST_REQUEST,
});

const signTestSuccess = () => ({
    type: actionTypes.RA_SUITABILITY_TEST_SIGN_TEST_SUCCESS,
});

const signTestFailure = (error = '') => ({
    type: actionTypes.RA_SUITABILITY_TEST_SIGN_TEST_FAILURE,
    payload: {
        error,
    },
});

const signTest = accessToken => (dispatch, getState) => {
    dispatch(signTestRequest());
    const immSuitabilityTest = getState().raSuitabilityTest;
    const immResults = immSuitabilityTest.getIn(['results', 0]);

    const payload = {
        clientRiskProfileDescription: immResults.get('clientRiskProfileDescription'),
        clientRiskProfileValue: immResults.get('clientRiskProfile'),
        maxTypeOfProduct: immResults.get('maxTypeOfProduct'),
        points: immResults.get('points') || 0,
        resultId: immResults.get('id'),
    };
    const request = {
        header: {
            Authorization: `Bearer ${accessToken}`,
            language: generateRoboLanguageParameter(),
        },
        query: payload,
    };

    const getRASignTestURL = apiURLBuilder.getURL('raSignTest');

    return post(getRASignTestURL, request)
        .then(() => {
            dispatch(checkStatusActions.checkStatus(accessToken));
            dispatch(signTestSuccess());
        })
        .catch(error => {
            preLoaderActions.hidePreLoader();
            if (error.error) {
                dispatch(signTestFailure(error.error.description));
            } else {
                dispatch(signTestFailure());
            }
            dispatch(goToErrorsView({ errorCode: error?.status, errorMessage: error?.error?.description }));
        });
};

const updateVolatilityValue = value => dispatch => {
    dispatch({
        type: actionTypes.RA_SUITABILITY_TEST_UPDATE_VOLATILITY_VALUE,
        payload: {
            value,
        },
    });
};

const updateCapitalRatioOption = value => dispatch => {
    dispatch({
        type: actionTypes.RA_SUITABILITY_TEST_UPDATE_CAPITAL,
        payload: {
            value,
        },
    });
};

const updateVolatilityInputValue = value => ({
    type: actionTypes.RA_SUITABILITY_TEST_UPDATE_VOLATILITY_INPUT_VALUE,
    payload: {
        value,
    },
});

const updateIncomingValue = value => dispatch => {
    dispatch({
        type: actionTypes.RA_SUITABILITY_TEST_UPDATE_INCOMING_VALUE,
        payload: {
            value,
        },
    });
};

const updateOutgoingValue = value => dispatch => {
    dispatch({
        type: actionTypes.RA_SUITABILITY_TEST_UPDATE_OUTGOING_VALUE,
        payload: {
            value,
        },
    });
};

const updateExpensesValue = value => dispatch => {
    dispatch({
        type: actionTypes.RA_SUITABILITY_TEST_UPDATE_EXPENSES_VALUE,
        payload: {
            value,
        },
    });
};

const updateTemporalHorizonValue = value => dispatch => {
    dispatch({
        type: actionTypes.RA_SUITABILITY_TEST_UPDATE_INVESTMENT_HORIZON_SLIDER,
        payload: {
            value,
        },
    });
};

const resetTestCompleted = () => ({
    type: actionTypes.RA_SUITABILITY_TEST_RESET_TEST_COMPLETED,
});

const resetAnswers = () => ({
    type: actionTypes.RA_SUITABILITY_TEST_RESET_ANSWERS,
});

const sendTestEmailInProgress = () => ({
    type: actionTypes.RA_SUITABILITY_TEST_SEND_TEST_EMAIL_IN_PROGRESS,
});

const sendTestEmailSuccess = () => ({
    type: actionTypes.RA_SUITABILITY_TEST_SEND_TEST_EMAIL_SUCCESS,
});

const sendTestEmailFailure = error => ({
    type: actionTypes.RA_SUITABILITY_TEST_SEND_TEST_EMAIL_FAILURE,
    payload: {
        error,
    },
});

const fillAccordionDefaultAnswers = () => ({
    type: actionTypes.RA_FILL_DEFAULT_ANSWERS_ACCORDION,
});

const sendTestEmail = () => (dispatch, getState) => {
    const accessToken = getState().userProfile?.accessToken;
    const request = {
        header: {
            Authorization: `Bearer ${accessToken}`,
        },
        query: {},
    };

    dispatch(sendTestEmailInProgress());

    return get(apiURLBuilder.getURL('raSendTestEmail'), request)
        .then(() => dispatch(sendTestEmailSuccess()))
        .catch(error => {
            if (error) {
                dispatch(sendTestEmailFailure(error));
            } else {
                throw error;
            }
        });
};

const sendOkSuitabilityTestService = (dispatch, requestData, callback) => {
    Api.post(apiURLBuilder.getURL('suitabilityTestOk'), requestData).then(
        response => {
            const data = response.body;
            if (data.status === 'OK') {
                callback(true, {});
            } else {
                callback(false, data.errors);
            }
        },
        error => {
            callback(false, error.body.errors);
        }
    );
};

const sendOkSuitabilityTest = (accessToken, callback) => {
    return dispatch => {
        const requestData = {
            header: {
                Authorization: `Bearer ${accessToken}`,
            },
            query: {},
        };
        sendOkSuitabilityTestService(dispatch, requestData, callback);
    };
};

const sendRoboRejectService = (dispatch, requestData, callback) => {
    Api.post(apiURLBuilder.getURL('roboReject'), requestData).then(
        response => {
            const data = response.body;
            if (data.status === 'OK') {
                callback(true, {});
            } else {
                callback(false, data.errors);
            }
        },
        error => {
            callback(false, error.body.errors);
        }
    );
};

const sendRoboReject = (accessToken, callback) => {
    return dispatch => {
        const requestData = {
            header: {
                Authorization: `Bearer ${accessToken}`,
            },
            query: {},
        };
        sendRoboRejectService(dispatch, requestData, callback);
    };
};

const sendGbiRejectService = (dispatch, requestData, callback) => {
    Api.post(apiURLBuilder.getURL('gbiReject'), requestData)
        .then(response => {
            const data = response.body;
            if (data.status === 'OK') {
                callback(true, {});
            } else {
                callback(false, data.errors);
            }
        })
        .catch(error => {
            if (error.error) {
                callback(false, error.body.errors);
            }
        });
};

const sendGbiReject = (accessToken, callback) => {
    return dispatch => {
        const requestData = {
            header: {
                Authorization: `Bearer ${accessToken}`,
            },
            query: {},
        };
        sendGbiRejectService(dispatch, requestData, callback);
    };
};

export default {
    expandAccordionRow,
    getTestQuestions,
    getTestResult,
    reset,
    resetAnswers,
    resetCoherenceError,
    resetTestCompleted,
    selectAccordionButton,
    sendTest,
    sendLogs,
    sendTestEmail,
    updateCapitalRatioOption,
    updateExpensesValue,
    updateIncomingValue,
    updateOutgoingValue,
    updateTemporalHorizonValue,
    updateVolatilityInputValue,
    updateVolatilityValue,
    validateStep,
    signTest,
    sendOkSuitabilityTest,
    sendRoboReject,
    sendGbiReject,
    clearCoherenceError,
    fillAccordionDefaultAnswers,
    updateAnswerByQuestionId,
};
